module.exports = __webpack_public_path__ + "static/media/dashboard.f8a11c1f.webp";